import { createSelector } from 'reselect'
import _forEach from 'lodash/forEach'
import _filter from 'lodash/filter'
import { getDiamondsInCart } from './cart'
import { getMarkupType, getCurrency } from './settings'
import { diamondPriceHelper } from './prices'

const DIAMOND_ID_FIELD = 'Diamond ID'
const getDiamondModalRow = state => state.diamondSearch.modalRow
const getSelectedDiamonds = state => state.diamondSearch.selectedItems
const getSupplierTypes = state => state.diamondSearch.filters.supplierTypes
const getAllSuppliers = state => state.diamondSearch.allSuppliers.data
const getDiamondType = (state) => state.diamondSearch.filters.diamondType

export const modalRowIsAddable = createSelector(
  [ getDiamondModalRow, getDiamondsInCart ],
  (diamond, diamondsInCart) => {
    const diamondIdsInCart = Object.values(diamondsInCart).map(item => item.data[DIAMOND_ID_FIELD])
    if (diamond && diamondIdsInCart) {
      return !diamondIdsInCart.includes(diamond[DIAMOND_ID_FIELD])
    }
    return false
  }
)

export const getSelectedAddableDiamonds = createSelector(
  [ getSelectedDiamonds, getDiamondsInCart ],
  (selectedDiamonds, diamondsInCart) => {
    const diamondIdsInCart = Object.values(diamondsInCart).map(item => item.data[DIAMOND_ID_FIELD])
    return selectedDiamonds.filter(item => !diamondIdsInCart.includes(item[DIAMOND_ID_FIELD]))
  }
)

export const getSelectedDiamondPrices = createSelector(
  [getSelectedDiamonds, getMarkupType, getCurrency],
  (diamonds, markupType, currency) => {
    let diamondPrices = {}
    _forEach(diamonds, (value, key) => {
      diamondPrices[key] = diamondPriceHelper(value, markupType, currency)
    })
    return diamondPrices
  }
)

export const getDiamondModalPrice = createSelector(
  [getDiamondModalRow, getMarkupType, getCurrency],
  (diamond, markupType, currency) => {
    return diamondPriceHelper(diamond, markupType, currency)
  }
)

export const getSuppliersForSelect = createSelector(
  [getSupplierTypes, getAllSuppliers, getDiamondType],
  (supplierTypes, allSuppliers, diamondType) => {
    if (diamondType === 'natural') {
      if (supplierTypes.length === 0) {
        return _filter(allSuppliers, (option) => !option.is_lab_grown)
      } else {
        return _filter(allSuppliers, (option) => {
          return (
            supplierTypes.includes(option.supplier_type) && !option.is_lab_grown
          )
        })
      }
    } else if (diamondType === 'lgd') {
      if (supplierTypes.length === 0) {
        return _filter(allSuppliers, (option) => option.is_lab_grown)
      } else {
        return _filter(allSuppliers, (option) => {
          return (
            supplierTypes.includes(option.supplier_type) && option.is_lab_grown
          )
        })
      }
    }
  }
)



// WEBPACK FOOTER //
// ./src/selectors/search.js